import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useDewasPphListModel} from "@/stores/models/dewas-pph-list-model";

export const useDewasPphListStore  = defineStore(
    'dewasPphListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourceDewasPphList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasPphListModel().dewasPphListCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceDewasPphList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceDewasPphList.value.reload();
        };

        return {
            dataSourceDewasPphList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai

        }
    }
);